export const commonInputValidationPattern = /^[a-zA-Z\u00C0-\u017F0-9.,;:!?'"()\s\-%&$@#^`~[\]{}|<>\\/*+=_]*$/;
export const numberValidationPattern = /^(\d+(\.\d*)?)?$/;
export const integerValidationPattern = /^(\d+)?$/;
export const tinValidationPattern = /^[\dX-]+$/;
export const ssnValidationPattern = tinValidationPattern;
export const emailRegex = /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
export const passCodeRegex = /^\d$/;
export const alphanumericRegExp = /^[a-zA-Z0-9]*$/;
export const lettersRegExp = /^[a-zA-Z]*$/;
export const alphanumericRegExpAndSpace = /^[a-zA-Z0-9 ]*$/;
export const reportedPolicyNumber = /^[a-zA-Z0-9]*$/;
export const phoneValidationPattern = /^\(?\d{0,3}\)? ?\d{0,3}-?\d{0,4}$/;
export const fullPhoneValidationPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
export const decimalRegExp = /^(\d+)?(\.\d{0,2})?$/;
export const lettersAndSpacesRegExp = /^[a-zA-Z\s]*$/;
export const searchAllowedCharsRegExp = /^[a-zA-Z0-9\s\-_/\\#.&()]*$/;
